<div class="container-fluid d-flex nav-wrapper h-100 p-0 align-items-center">
  <span
    class="nav-name d-flex justify-content-center flex-column cursor-pointer"
    (click)="navLinkClick('all_projects')"
    (keydown)="navLinkClick('all_projects')"
  >
    <img
      class="logo"
      [src]="'images/logo/helio-assure.svg' | assetUrl"
      alt="Icon"
    />
  </span>
  <span
    class="d-flex flex-grow-1 align-items-center"
    [ngClass]="{ 'header-title': title }"
  >
    {{ title }}

    <span class="beta-badge" *ngIf="isAgentic">
      Beta
      <img [src]="'images/virtusa-icons/diamond-outline.svg' | assetUrl" alt="Diamond outline icon" />
    </span>
  </span>

  <!-- Header Tabs -->
  <div class="header-tabs" *ngIf="isAuthenticated && (projectType === 'project' || projectType === 'telemetry')">
    <button 
      class="tab-btn" 
      [class.active]="selectedTab === 'projects'"
      (click)="selectTab('projects')"
    >
      Projects
    </button>
    <button *ngIf="isTelemetryDashboardEnabled"
      class="tab-btn" 
      [class.active]="selectedTab === 'telemetry'"
      (click)="selectTab('telemetry')"
    >
      Telemetry Dashboard
    </button>
  </div>

  <button *ngIf="!isAuthenticated"
    type="button"
    class="btn m-auto btn-accello-primary-banner"
    (click)="onLogOrLogout()"
  >
    <span class="btn-text m-auto mx-auto">
      {{ "Login" }}
    </span>
  </button>

  <div class="profile-menu-container">
    <button
      class="profile-btn v-center "
      type="button"
      [attr.aria-label]="'User profile: ' + userProfile?.name"
      [title]="userProfile?.name"
      (click)="toggleProfileMenu()"
    >
      <span class="profile-initials">{{ getInitials(userProfile?.name) }}</span>
    </button>
    <div *ngIf="isProfileMenuOpen" class="profile-menu">
      <div class="menu-body container-fluid overflow-auto px-3 d-flex flex-column">
        <div class="d-flex align-items-start justify-content-start flex-row mb-3">
          <button
            class="profile-btn v-center mx-3"
            type="button"
            [attr.aria-label]="'User profile: ' + userProfile?.name"
            [title]="userProfile?.name"
          >
            <span class="profile-initials">{{ configs.initials }}</span>
          </button>
      
          <div class="d-flex flex-column mt-1">
            <span class="header-coverage">{{ configs.name }}</span>
            <span class="general-text-8">{{ configs.email }}</span>
          </div>
        </div>
      
        <div class="ai-approach-container mt-3" *ngIf="configs.projectId && isAgenticEnabled">
          <div class="d-flex flex-row align-items-center justify-content-between">
            <span class="config-title">{{ configs.type }}</span>
            <span class="beta-badge">
              Beta
              <img [src]="'images/virtusa-icons/diamond-outline.svg' | assetUrl" alt="Diamond outline icon" />
            </span>
            <div class="switch-container">
              <label class="custom-switch">
                <input
                  type="checkbox"
                  [checked]="isAgentic"
                  (change)="toggle()"
                  [disabled]="isTogglingAiApproach"
                />
                <span class="custom-slider"></span>
              </label>
            </div>
          </div>
          <div *ngIf="isTogglingAiApproach" class="spinner-overlay">
            <div class="spinner"></div>
          </div>
        </div>
      </div>
      
      <div class="footer-div">
          <div class="logout-div">
              <img
              class="signout"
              src="assets/images/virtusa-icons/signout.svg"
              alt="User avatar"
              onerror="this.style.display='none'"
            />
      
            <span class="header-coverage gray-cov" (click)="signOut()" (keydown.enter)="signOut()">Sign out</span>
          </div>
      </div>
      
    </div>
  </div>
</div>
